import { InvoiceLineField, InvoiceSection, matchIndexedChild } from '@insio/validation';
import type { ValidationIssue } from '../../../../types';

// Backend emits `unitPriceNoVat` / `unitPriceInclVat` (two separate columns);
// the form folds them into a single `unitPrice` field driven by the
// `isUnitPriceInclVat` toggle. Rewrite both variants so per-cell error
// lookups hit the unit-price input.
const UNIT_PRICE_RENAME: Record<string, string> = {
  [InvoiceLineField.unitPriceNoVat]: InvoiceLineField.unitPrice,
  [InvoiceLineField.unitPriceInclVat]: InvoiceLineField.unitPrice
};

/**
 * Rebase invoice-line validation issues for use inside the lines form.
 * Renames backend unit-price field variants to the form's unified `unitPrice`.
 */
export function rebaseInvoiceLineIssues(issues: readonly ValidationIssue[]): ValidationIssue[] {
  return issues.map(issue => {
    if (!issue.path) return issue;
    const match = matchIndexedChild(issue.path, InvoiceSection.invoiceLines);
    if (!match || !match.child) return issue;
    const rename = UNIT_PRICE_RENAME[match.child];
    if (!rename) return issue;
    return { ...issue, path: `${InvoiceSection.invoiceLines}.${match.index}.${rename}` };
  });
}
